<h2 mat-dialog-title>
  {{ isEditMode ? "Edit Category" : "Add New Category" }}
</h2>

<mat-dialog-content>
  <form #catForm="ngForm">
    <!-- Category Name -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Category Name</mat-label>
      <input matInput name="categoryName" [(ngModel)]="categoryName" required />
      @if (catForm.submitted && !categoryName) {
        <mat-error>
          Name is required
        </mat-error>
      }
    </mat-form-field>

    <!-- Description -->
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Description</mat-label>
      <textarea
        matInput
        name="categoryDescription"
        rows="2"
        [(ngModel)]="categoryDescription"
      ></textarea>
    </mat-form-field>

    <!-- File Upload -->
    <!-- <div class="file-input">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="fileInput.click()"
      >
      <mat-icon>upload</mat-icon>
      <span>Upload Image</span>
    </button>
    <input
      #fileInput
      type="file"
      hidden
      accept="image/*"
      (change)="onFileSelected($event)"
      />
    <span class="file-name" *ngIf="selectedFile">
      {{ selectedFile.name }}
    </span>
  </div> -->

  <!-- Preview -->
  @if (previewImage) {
    <div class="preview-container">
      <p>Preview:</p>
      <img [src]="previewImage" alt="Category Preview" />
    </div>
  }
</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cancel</button>
  <button mat-flat-button color="primary" (click)="submitCategory()">
    {{ isEditMode ? "Save Changes" : "Add" }}
  </button>
</mat-dialog-actions>
